import type { ListProps, QueryProps } from "shared/react";
import { List } from "shared/react";
import { FOLLOWING_MAX, type ProfileData } from "shared/schema";
import { useQuery } from "../util/db.js";
import { ProfileCard, RawProfileCard } from "./ProfileCard.js";

export function ProfileList({ query, ...props }: QueryProps<ProfileData>): React.ReactElement {
	return (
		<List //
			store={useQuery("profile", query)}
			mapper={data => <RawProfileCard key={data.id} uid={data.id} profile={data} />}
			more="Show more profiles"
			empty="No profiles"
			{...props}
		/>
	);
}

export function FollowerProfileList({ followed, ...props }: { followed: string } & ListProps): React.ReactElement {
	return (
		<List //
			store={useQuery("following", { followed, $order: "!updated", $limit: FOLLOWING_MAX })}
			mapper={({ follower }) => <ProfileCard key={follower} uid={follower} />}
			more="Show more profiles"
			empty="No profiles"
			{...props}
		/>
	);
}

export function FollowedProfileList({ follower, ...props }: { follower: string } & ListProps): React.ReactElement {
	return (
		<List //
			store={useQuery("following", { follower, $order: "!updated", $limit: FOLLOWING_MAX })}
			mapper={({ followed }) => <ProfileCard key={followed} uid={followed} />}
			more="Show more profiles"
			empty="No profiles"
			{...props}
		/>
	);
}
